var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubblesAnimation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "edktTJQeS0l1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60.702393 42.604145",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l3-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l3-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l9-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l9-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l9-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l9-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l9-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l9-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l14-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l14-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l20-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l20-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l20-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l20-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l20-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l20-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l25-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l25-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l31-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l31-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l31-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l31-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l31-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l31-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l36-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l36-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l42-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l42-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l42-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l42-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l42-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l42-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l47-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l47-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l53-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l53-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l53-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l53-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l53-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l53-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l57-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l57-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l63-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l63-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l63-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l63-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l63-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l63-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l68-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l68-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l74-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l74-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l74-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l74-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l74-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l74-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l78-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l78-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l84-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l84-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l84-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l84-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l84-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l84-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l88-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l88-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l94-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l94-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l94-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l94-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l94-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l94-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l98-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l98-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l104-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l104-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l104-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l104-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l104-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l104-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l108-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l108-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l114-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l114-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l114-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l114-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l114-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l114-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l118-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l118-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l124-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l124-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l124-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l124-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l124-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l124-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l128-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l128-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l134-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l134-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l134-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l134-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l134-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l134-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l138-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l138-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l144-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l144-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l144-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l144-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l144-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l144-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l148-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l148-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l154-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l154-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l154-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l154-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l154-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l154-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l158-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l158-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l164-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l164-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l164-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l164-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l164-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l164-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l168-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l168-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l174-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l174-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l174-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l174-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l174-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l174-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l178-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l178-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l184-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l184-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l184-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l184-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l184-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l184-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l188-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l188-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l194-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l194-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l194-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l194-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l194-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l194-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l198-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l198-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l204-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l204-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l204-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l204-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l204-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l204-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l208-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l208-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l214-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l214-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l214-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l214-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l214-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l214-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l219-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l219-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l225-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l225-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l225-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l225-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l225-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l225-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l229-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l229-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l235-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l235-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l235-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l235-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l235-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l235-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l239-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l239-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l245-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l245-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l245-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l245-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l245-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l245-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l249-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l249-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l255-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l255-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l255-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l255-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l255-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l255-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l259-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l259-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l265-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l265-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l265-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l265-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l265-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l265-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l269-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l269-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l275-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l275-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l275-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l275-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l275-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l275-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l279-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l279-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l285-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l285-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l285-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l285-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l285-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l285-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l289-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l289-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l295-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l295-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l295-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l295-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l295-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l295-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l299-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l299-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l305-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l305-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l305-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l305-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l305-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l305-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l309-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l309-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l315-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l315-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l315-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l315-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l315-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l315-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l319-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l319-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l325-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l325-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l325-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l325-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l325-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l325-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l329-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l329-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l335-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l335-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l335-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l335-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l335-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l335-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l339-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l339-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l345-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l345-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l345-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l345-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l345-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l345-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l350-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l350-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l356-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l356-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l356-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l356-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l356-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l356-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l361-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l361-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l367-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l367-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l367-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l367-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l367-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l367-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l372-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l372-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l378-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l378-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l378-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l378-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l378-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l378-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l383-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l383-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l389-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l389-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l389-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l389-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l389-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l389-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l394-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l394-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l400-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l400-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l400-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l400-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l400-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l400-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l405-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l405-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l411-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l411-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l411-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l411-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l411-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l411-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l416-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l416-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l422-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l422-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l422-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l422-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l422-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l422-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l427-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l427-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l433-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l433-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l433-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l433-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l433-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l433-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l438-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l438-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l444-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l444-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l444-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l444-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l444-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l444-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l449-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l449-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l455-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l455-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l455-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l455-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l455-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l455-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l460-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l460-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l466-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l466-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l466-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l466-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l466-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l466-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l471-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l471-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l477-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l477-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l477-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l477-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l477-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l477-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l482-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l482-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l488-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l488-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l488-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l488-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l488-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l488-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l493-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l493-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l499-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l499-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l499-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l499-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l499-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l499-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l504-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l504-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l510-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l510-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l510-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l510-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l510-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l510-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l515-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l515-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l521-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l521-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l521-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l521-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l521-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l521-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l526-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l526-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l532-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l532-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l532-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l532-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l532-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l532-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l537-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l537-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l543-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l543-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l543-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l543-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l543-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l543-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l548-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l548-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l554-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l554-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l554-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l554-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l554-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l554-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l559-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l559-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l565-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l565-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l565-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l565-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l565-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l565-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l570-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l570-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l576-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l576-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l576-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l576-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l576-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l576-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l581-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l581-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l587-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l587-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l587-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l587-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l587-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l587-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l592-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l592-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l598-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l598-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l598-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l598-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l598-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l598-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l603-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l603-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l609-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l609-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l609-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l609-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l609-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l609-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l613-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l613-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l619-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l619-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l619-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l619-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l619-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l619-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l623-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l623-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l629-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l629-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l629-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l629-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l629-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l629-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l633-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l633-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l639-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l639-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l639-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l639-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l639-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l639-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l643-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l643-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l649-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l649-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l649-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l649-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l649-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l649-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l653-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l653-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l659-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l659-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l659-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l659-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l659-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l659-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l664-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l664-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l670-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l670-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l670-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l670-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l670-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l670-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l675-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l675-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l681-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l681-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l681-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l681-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l681-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l681-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l686-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l686-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l692-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l692-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l692-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l692-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l692-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l692-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l697-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l697-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l703-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l703-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l703-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l703-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l703-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l703-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l708-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l708-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l714-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l714-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l714-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l714-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l714-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l714-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l719-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l719-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l725-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l725-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l725-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l725-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l725-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l725-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l730-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l730-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l736-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l736-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l736-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l736-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l736-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l736-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l740-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l740-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l746-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l746-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l746-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l746-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l746-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l746-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l750-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l750-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l756-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l756-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l756-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l756-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l756-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l756-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l761-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l761-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l767-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l767-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l767-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l767-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l767-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l767-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l772-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l772-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l778-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l778-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l778-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l778-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l778-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l778-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l783-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l783-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l789-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l789-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l789-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l789-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l789-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l789-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l794-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l794-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l800-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l800-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l800-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l800-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l800-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l800-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l805-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l805-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l811-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l811-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l811-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l811-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l811-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l811-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l816-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l816-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l822-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l822-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l822-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l822-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l822-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l822-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l826-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l826-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l832-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l832-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l832-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l832-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l832-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l832-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "edktTJQeS0l836-filter",
    x: "-150%",
    width: "400%",
    y: "-150%",
    height: "400%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    id: "edktTJQeS0l836-filter-blur-0",
    stdDeviation: "1,1",
    result: "result"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l842-fill",
    x1: 71.551664,
    y1: 90.928342,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l842-fill-0",
    offset: "0%",
    stopColor: "#00f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l842-fill-1",
    offset: "67.84566%",
    stopColor: "rgba(0,245,245,0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "edktTJQeS0l842-stroke",
    x1: 77.476263,
    y1: 87.015462,
    x2: 74.746999,
    y2: 115.31148,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l842-stroke-0",
    offset: "0%",
    stopColor: "#00f5ed"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "edktTJQeS0l842-stroke-1",
    offset: "100%",
    stopColor: "rgba(153,255,252,0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.51695-.355122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l3",
    transform: "matrix(.078201 0.000011-.000012 0.079878 35.752371 36.624406)",
    filter: "url(#edktTJQeS0l3-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l6)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l9-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l9-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l10"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l14",
    transform: "matrix(.078201 0.000011-.000012 0.079878 27.222337 36.922045)",
    filter: "url(#edktTJQeS0l14-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l17)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l21)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l20-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l20-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l21"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.082234 0.164468)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l25",
    transform: "matrix(.078201 0.000011-.000012 0.079878-5.983833 37.35496)",
    filter: "url(#edktTJQeS0l25-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l28)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l28"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l31-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l31-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.087978 0.000001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l36",
    transform: "matrix(.088574 0.000013-.000012 0.079878 11.613499 36.596662)",
    filter: "url(#edktTJQeS0l36-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l39)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l39"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l43)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l42-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l42-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l43"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l47",
    transform: "matrix(.043383 0.000006-.000007 0.049121-.614886 37.929631)",
    filter: "url(#edktTJQeS0l47-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l50)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l54)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l53-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l53-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l57",
    transform: "matrix(.043383 0.000006-.000007 0.049121 18.144019 38.838653)",
    filter: "url(#edktTJQeS0l57-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l60)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l64)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l63-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l63-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.1446 1.452331)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l68",
    transform: "matrix(.088574 0.000013-.000012 0.079878 11.613499 36.596662)",
    filter: "url(#edktTJQeS0l68-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l71)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l74-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l74-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l75"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l78",
    transform: "matrix(.043383 0.000006-.000007 0.049121 36.443398 38.750675)",
    filter: "url(#edktTJQeS0l78-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l81)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l81"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l85)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l84-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l84-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l85"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l88",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.348557 36.790253)",
    filter: "url(#edktTJQeS0l88-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l91)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l91"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l95)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l94-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l94-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l95"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l98",
    transform: "matrix(.06931 0.00001-.000011 0.076694-1.440996 37.944152)",
    filter: "url(#edktTJQeS0l98-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l101)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l101"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l104-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l104-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l108",
    transform: "matrix(.026166 0.000004-.000004 0.024909 4.367096 40.975016)",
    filter: "url(#edktTJQeS0l108-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l111)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l114-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l114-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l118",
    transform: "matrix(.063565 0.000009-.000011 0.076694 5.082652 34.016717)",
    filter: "url(#edktTJQeS0l118-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l121)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l124-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l124-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l128",
    transform: "matrix(.06931 0.00001-.000011 0.076694 8.899893 44.440691)",
    filter: "url(#edktTJQeS0l128-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l131)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l131"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l134-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l134-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l138",
    transform: "matrix(.054628 0.000008-.000008 0.053767 22.087775 40.709129)",
    filter: "url(#edktTJQeS0l138-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l141)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l144-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l144-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l148",
    transform: "matrix(.06931 0.00001-.000011 0.076694 8.914641 37.172988)",
    filter: "url(#edktTJQeS0l148-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l151)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l154-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l154-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l158",
    transform: "matrix(.06931 0.00001-.000011 0.076694 25.219261 39.706814)",
    filter: "url(#edktTJQeS0l158-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l161)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l164-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l164-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l168",
    transform: "matrix(.06931 0.00001-.000011 0.076694 33.493124 41.468436)",
    filter: "url(#edktTJQeS0l168-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l171)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l175)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l174-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l174-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l175"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l178",
    transform: "matrix(.026166 0.000004-.000004 0.024909 22.600648 41.485046)",
    filter: "url(#edktTJQeS0l178-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l181)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l184-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l184-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l188",
    transform: "matrix(.026166 0.000004-.000004 0.024909 23.342054 37.927485)",
    filter: "url(#edktTJQeS0l188-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l191)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l191"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l195)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l194-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l194-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l198",
    transform: "matrix(.032193 0.000005-.000005 0.034866 44.320868 42.582391)",
    filter: "url(#edktTJQeS0l198-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l201)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l204-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l204-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l208",
    transform: "matrix(.032193 0.000005-.000005 0.034866 51.987005 42.419282)",
    filter: "url(#edktTJQeS0l208-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l211)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l214-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l214-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.000001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l219",
    transform: "matrix(.06931 0.00001-.000011 0.076694-2.730635 43.995402)",
    filter: "url(#edktTJQeS0l219-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l222)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l226)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l225-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l225-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l229",
    transform: "matrix(.032239 0.000005-.000004 0.029797-2.476794 36.823734)",
    filter: "url(#edktTJQeS0l229-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l232)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l235-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l235-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l236"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l239",
    transform: "matrix(.06931 0.00001-.000011 0.076694 29.603659 42.818702)",
    filter: "url(#edktTJQeS0l239-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l242)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l245-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l245-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l249",
    transform: "matrix(.06931 0.00001-.000011 0.076694 7.695022 40.36783)",
    filter: "url(#edktTJQeS0l249-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l252)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l255-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l255-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l256"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l259",
    transform: "matrix(.06931 0.00001-.000011 0.076694 19.968391 41.333236)",
    filter: "url(#edktTJQeS0l259-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l262)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l265-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l265-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l269",
    transform: "matrix(.043383 0.000006-.000007 0.049121 13.800253 42.810825)",
    filter: "url(#edktTJQeS0l269-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l272)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l275-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l275-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l279",
    transform: "matrix(.06931 0.00001-.000011 0.076694 2.144052 37.251715)",
    filter: "url(#edktTJQeS0l279-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l282)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l285-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l285-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l289",
    transform: "matrix(.043383 0.000006-.000007 0.049121 23.936454 39.858533)",
    filter: "url(#edktTJQeS0l289-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l292)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l295-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l295-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l299",
    transform: "matrix(.041126 0.000006-.000007 0.049121 34.221976 38.08718)",
    filter: "url(#edktTJQeS0l299-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l302)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l302"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l305-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l305-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l309",
    transform: "matrix(.032239 0.000005-.000004 0.029797 13.309712 37.614708)",
    filter: "url(#edktTJQeS0l309-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l312)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l315-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l315-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l319",
    transform: "matrix(.032239 0.000005-.000004 0.029797 3.867643 43.047132)",
    filter: "url(#edktTJQeS0l319-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l322)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l322"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l325-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l325-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l329",
    transform: "matrix(.06931 0.00001-.000011 0.076694-3.283414 41.5279)",
    filter: "url(#edktTJQeS0l329-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l332)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l332"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l335-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l335-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l336"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l339",
    transform: "matrix(.041126 0.000006-.000007 0.049121 2.282273 39.634563)",
    filter: "url(#edktTJQeS0l339-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l342)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l345-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l345-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.582487 0.072956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l350",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l350-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l353)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l353"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l356-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l356-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.847947 0.145913)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l361",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l361-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l364)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l368)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l367-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l367-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l368"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.085556 0.437738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l372",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l372-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l375)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l375"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l378-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l378-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l379"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.973635 0.364782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l383",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l383-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l386)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l390)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l389-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l389-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.964846 0.364782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l394",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l394-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l400-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l400-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.964846 2.40756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l405",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l405-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l408)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l411-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l411-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.610839 2.900015)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l416",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l416-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l419)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l422-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l422-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l423"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-7.095008 3.81197)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l427",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l427-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l430)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l433-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l433-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.766704 2.991211)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l438",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l438-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l441)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l441"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l445)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l444-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l444-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l445"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.534733-1.595921)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l449",
    transform: "matrix(.032239 0.000005-.000004 0.029797 3.867643 43.047132)",
    filter: "url(#edktTJQeS0l449-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l452)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l452"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l455-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l455-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1.008879 7.143645-3.101109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l460",
    transform: "matrix(.032239 0.000005-.000004 0.029797 3.867643 43.047132)",
    filter: "url(#edktTJQeS0l460-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l463)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l463"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l466-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l466-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.771329-1.859797)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l471",
    transform: "matrix(.032239 0.000005-.000004 0.029797 3.867643 43.047132)",
    filter: "url(#edktTJQeS0l471-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l474)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l477-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l477-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.038363-2.781593)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l482",
    transform: "matrix(.032239 0.000005-.000004 0.029797 3.867643 43.047132)",
    filter: "url(#edktTJQeS0l482-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l485)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l488-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l488-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 0.986757 52.873632-2.306141)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l493",
    transform: "matrix(.032239 0.000005-.000004 0.029797 3.867643 43.047132)",
    filter: "url(#edktTJQeS0l493-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l496)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l499-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l499-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(35.350913-2.862525)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l504",
    transform: "matrix(.032239 0.000005-.000004 0.029797 3.867643 43.047132)",
    filter: "url(#edktTJQeS0l504-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l507)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l507"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l510-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l510-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l511"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.151926 0.742151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l515",
    transform: "matrix(.041126 0.000006-.000007 0.049121 2.282273 39.634563)",
    filter: "url(#edktTJQeS0l515-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l518)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l518"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l522)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l521-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l521-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l522"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.758022 0.329844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l526",
    transform: "matrix(.041126 0.000006-.000007 0.049121 2.282273 39.634563)",
    filter: "url(#edktTJQeS0l526-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l529)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l532-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l532-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.74415-.054238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l537",
    transform: "matrix(.041126 0.000006-.000007 0.049121 2.282273 39.634563)",
    filter: "url(#edktTJQeS0l537-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l540)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l540"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l544)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l543-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l543-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l544"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(43.336702 2.250253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l548",
    transform: "matrix(.041126 0.000006-.000007 0.049121 2.282273 39.634563)",
    filter: "url(#edktTJQeS0l548-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l551)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l555)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l554-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l554-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.442439 2.473836)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l559",
    transform: "matrix(.041126 0.000006-.000007 0.049121 2.282273 39.634563)",
    filter: "url(#edktTJQeS0l559-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l562)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l565-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l565-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.868259 5.135201)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l570",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l570-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l573)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l577)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l576-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l576-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l577"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.256941 3.238594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l581",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l581-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l584)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l587-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l587-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.890455 2.826288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l592",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l592-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l595)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l598-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l598-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-24.07378 3.238594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l603",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l603-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l606)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l606"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l610)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l609-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l609-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l610"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l613",
    transform: "matrix(.06931 0.00001-.000011 0.076694 22.538035 40.780136)",
    filter: "url(#edktTJQeS0l613-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l616)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l620)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l619-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l619-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l620"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l623",
    transform: "matrix(.06931 0.00001-.000011 0.076694 5.272725 40.007063)",
    filter: "url(#edktTJQeS0l623-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l626)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l626"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l630)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l629-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l629-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l630"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l633",
    transform: "matrix(.06931 0.00001-.000011 0.076694 17.384212 42.15449)",
    filter: "url(#edktTJQeS0l633-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l636)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l636"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l639-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l639-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l643",
    transform: "matrix(.06931 0.00001-.000011 0.076694 7.162461 41.725005)",
    filter: "url(#edktTJQeS0l643-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l646)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l649-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l649-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l653",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l653-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l656)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l660)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l659-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l659-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l660"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.190987-.60128)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l664",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l664-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l667)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l671)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l670-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l670-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l671"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.871765-3.865369)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l675",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l675-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l678)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l678"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l681-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l681-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14.430707 0.085896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l686",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l686-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l689)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l692-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l692-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.142252-.343589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l697",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l697-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l700)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l700"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l703-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l703-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l704"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.690629 0.424574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l708",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l708-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l711)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l711"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l714-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l714-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.020415 0.687176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l719",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l719-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l722)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l725-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l725-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.492237 0.085896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l730",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l730-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l733)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l733"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l736-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l736-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l737"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l740",
    transform: "matrix(.032193 0.000005-.000005 0.034866 17.864571 40.520861)",
    filter: "url(#edktTJQeS0l740-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l743)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l743"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l746-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l746-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l750",
    transform: "matrix(.06931 0.00001-.000011 0.076694 8.801772 41.870092)",
    filter: "url(#edktTJQeS0l750-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l753)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l756-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l756-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.472616-2.071167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l761",
    transform: "matrix(.06931 0.00001-.000011 0.076694 13.948329 42.068593)",
    filter: "url(#edktTJQeS0l761-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l764)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l767-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l767-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l768"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.915681 5.745309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l772",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l772-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l775)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l778-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l778-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l779"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.211848 1.136328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l783",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l783-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l786)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l789-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l789-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.914294 0.598614)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l794",
    transform: "matrix(.06931 0.00001-.000011 0.076694 23.129688 36.571384)",
    filter: "url(#edktTJQeS0l794-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l797)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l800-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l800-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.712672 0.768164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l805",
    transform: "matrix(.06931 0.00001-.000011 0.076694 5.272725 40.007063)",
    filter: "url(#edktTJQeS0l805-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l808)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l808"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l811-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l811-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.557652-2.458123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l816",
    transform: "matrix(.06931 0.00001-.000011 0.076694 5.272725 40.007063)",
    filter: "url(#edktTJQeS0l816-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l819)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l822-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l822-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l826",
    transform: "matrix(.043383 0.000006-.000007 0.049121 40.839613 41.42813)",
    filter: "url(#edktTJQeS0l826-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l829)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l832-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l832-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "edktTJQeS0l836",
    transform: "matrix(.06931 0.00001-.000011 0.076694 39.240256 40.429785)",
    filter: "url(#edktTJQeS0l836-filter)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l839)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(76.5359 74.8426)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#99fffc",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edktTJQeS0l843)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.48118,90.928734c.000002,6.7037-7.832312,12.185567-17.655074,12.356856s-18.05533-5.030441-18.557297-11.725388s6.909639-12.442634,16.706749-12.956052s18.408425,4.394589,19.411052,11.063297",
    opacity: 0.481343,
    fill: "url(#edktTJQeS0l842-fill)",
    fillRule: "evenodd",
    stroke: "url(#edktTJQeS0l842-stroke)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "edktTJQeS0l843"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44.7024,
    height: 42.3318,
    rx: 22.351196,
    ry: 21.165907,
    transform: "translate(75.52 74.504)",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#9bfffc",
    strokeWidth: 1.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M104.64424,90.0821c0,1.652966-3.879556,3.004659-8.745035,3.046895s-8.943293-1.240383-9.191932-2.891191s3.422532-3.068047,8.275306-3.194643s9.118194,1.083598,9.614821,2.727937",
    transform: "matrix(.454762-.25992 0.242978 0.48647 24.0101 64.184)",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubblesAnimation);
export default __webpack_public_path__ + "static/media/bubblesAnimation.61f06d11f4701c34495d21d4c873e644.svg";
export { ForwardRef as ReactComponent };